import {
  addDays,
  addMonths,
  format,
  formatDistanceToNowStrict,
  startOfMonth,
} from 'date-fns';
import { ru } from 'date-fns/locale';
import { PartnerClientsTableDictionary } from 'types/i18n';
import { normalizeProfileLike } from 'utils/profileLikeUtils';
import { sharedDictionaryRu } from './sharedDictionaryRu';

export const partnerClientsTableDictionaryRu: PartnerClientsTableDictionary = {
  organizationLabel: 'Организация',
  contactFullNameLabel: 'Контакт',
  positionLabel: 'Должность',
  phoneLabel: 'Телефон',
  orgSizeLabel: 'Штат',
  licensesCountLabel: 'Лицензий',
  incomeLabel: 'Ваш доход',
  paybackLabel: 'Оплата',
  expectedIncomeLabel: 'Прогноз дохода',
  subscribtionStatusLabel: 'Подписка',
  willBeDeletedInDaysLabel: 'Будет утерян',
  expectedIncomeTooltipText:
    'Ваш доход в месяц с клиента после завершения пробного периода',

  incomeTooltipText(item) {
    const { income } = item;

    if (income === null) {
      return 'В этом месяце использование программы для клиента бесплатно';
    }

    if (income.monthly) {
      return 'Ваш доход с клиента за весь месяц использования программы';
    }

    return 'Ваш доход с клиента за часть месяца, в которую клиент использовал программу';
  },
  expiredPaybackTooltipText: 'Клиент должен оплатить счет',
  paidPaybackTooltipText: 'Счет оплачен, ваш доход зачислен на баланс',

  subscribtionStatusValue({ subscription }) {
    if (subscription.status === 'CANCELLED') {
      const dateObj = new Date(subscription.cancellationDateISO);

      const formattedDate = sharedDictionaryRu.dates.fd14(dateObj);

      return `Отменена ${formattedDate}`;
    }

    if (subscription.status === 'ACTIVE') {
      if (subscription.activationDateISO) {
        const dateObj = new Date(subscription.activationDateISO);

        const formattedDate = sharedDictionaryRu.dates.fd14(dateObj);

        return `Активна c ${formattedDate}`;
      }

      return 'Активна';
    }

    if (subscription.status === 'TRIAL') {
      const endDateObj = new Date(subscription.endDateISO);

      const formattedDate = sharedDictionaryRu.dates.fd14(endDateObj);

      return `Пробный до ${formattedDate}`;
    }

    return '-';
  },
  orgSizeValue(orgSize) {
    switch (orgSize) {
      case 'large':
        return 'более 500';
      case 'medium':
        return 'до 500';
      case 'small':
        return 'до 100';
      default:
        return '';
    }
  },
  incomeValue(income) {
    return sharedDictionaryRu.moneyAmountText(income, 'USD');
  },

  contactFullNameText(item) {
    return normalizeProfileLike(item).toFullName();
  },
  firstPaybackDateText(baseDateISO) {
    const nextMonthStartDate = startOfMonth(
      addMonths(new Date(baseDateISO), 1)
    );

    const formattedDateText = format(nextMonthStartDate, 'd MMMM', {
      locale: ru,
    })
      // WARNING: date-fns почему-то вставляет символ таба вместо пробела, заменяем
      .replace('	', ' ');

    return `c ${formattedDateText}`;
  },
  willBeDeletedInDaysText(daysNumber) {
    const willBeDeletedOnDate = addDays(new Date(), daysNumber);

    const distanceText = formatDistanceToNowStrict(willBeDeletedOnDate, {
      locale: ru,
      addSuffix: true,
      unit: 'day',
    });

    return distanceText;
  },
};
